import ActivitiesPage from "../../pages/legacy/activities/ActivitiesPage";

const route = {
  key: "activities",
  path: "/legacy/activities",
  component: ActivitiesPage,
  private: true,
  layout: "main",
  icon: "faTasks",
  group: "sales",
  order: 40,
  permission: "legacy.activities.read"
};

export default route;